import { createStructuredSelector } from 'reselect';
import { suggestedProductsSelector, listOfNearestVariantsSelector, logoSelector } from '../../../../../../../redux/cart/cart.selectors';
export const suggestedProductListSelector = createStructuredSelector({
  suggestedProducts: suggestedProductsSelector,
  listOfNearestVariants: listOfNearestVariantsSelector,
  logoUrl: logoSelector
});